import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsEntire = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={8} colSpan={2}>Project Management (Entire Department)</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.entire.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>$ {numberFormatter(dateHeader.entire.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Completed Last 7 days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.entire.week.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>$ {numberFormatter(dateHeader.entire.week.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Completed Quarter to Date</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.entire.quarter.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>$ {numberFormatter(dateHeader.entire.quarter.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Completed Year to Date</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.entire.year.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>$ {numberFormatter(dateHeader.entire.year.amount)}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsEntire.propTypes = {
  data: PropTypes.object
}
